<div class="px-2" [hidden]="inCategoryView || categories?.length <= 0">
    <!--Header-->
    <div class="d-flex">
        <!--Spacer for showSelectedToggle state-->
        <button type="button" class="btn btn-text d-flex align-items-center align-self-end font-size-12 lato-regular" style="white-space:nowrap; visibility:hidden; height:1px" *ngIf="showSelectedToggle">
            <div class="rounded border color-cerulean mr-2" style="height:0.5rem; width:0.5rem"></div>
            <div cvLocalizedText langSection="Admin_Attributes" langKey="View_By">View by</div>
        </button>

        <div class="lato-bold" [ngSwitch]="attributeType">
            <span *ngSwitchCase="0" cvLocalizedText langSection="Admin_Attributes" langKey="Data_Attributes">Data Attributes</span>
            <span *ngSwitchCase="1" cvLocalizedText langSection="Admin_Attributes" langKey="User_Attributes">User Attributes</span>
        </div>
    </div>

    <!--Selected Attribute List-->
    <div [hidden]="model.SelectedCategories.length <= 0" *ngIf="initialized">
        <div class="d-flex mt-2" *ngFor="let category of model.SelectedCategories">
            <button type="button" class="btn btn-text d-flex align-items-center align-self-end font-size-12" style="white-space:nowrap"
                    [ngClass]="{ 'lato-bold': (category.SelectedCategoryID == model.GroupedCategoryID), 'lato-regular': (category.SelectedCategoryID != model.GroupedCategoryID) }"
                    (click)="onGroupByCategoryClicked(category.SelectedCategoryID)" title="The table will display data about the level chosen." *ngIf="showSelectedToggle">
                <div class="rounded border color-cerulean mr-2" [ngClass]="{ 'bg-cerulean': category.SelectedCategoryID == model.GroupedCategoryID }" style="height:0.5rem; width:0.5rem; border-color:currentColor"></div>
                <div cvLocalizedText langSection="Admin_Attributes" langKey="View_By">View by</div>
            </button>

            <div class="flex-fill d-flex flex-column" [ngClass]="{'mx-3': !showSelectedToggle}" [style.max-width]="showSelectedToggle ? '228px' : '280px'">
                <div class="body-2 color-whaleTail mb-1">{{categoriesById[category.SelectedCategoryID]?.CategoryName}}</div>

                <div class="d-flex">
                    <mat-form-field class="cv-material-control" appearance="fill">
                        <!--<mat-label>Select an option</mat-label>-->
                        <mat-select class="flex-fill my-auto w-100 lato-regular" [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + category.SelectedCategoryID) | cleanId"
                                    panelClass="cv-material-control" [value]="category.SelectedAttributeIDs" [disabled]="service.attributeValues[attributeType][category.SelectedCategoryID] == null"
                                    (openedChange)="$event ? onSelectorOpen() : onSelectorClose(category)" [multiple]="true" [disableRipple]="true" [attr.category-id]="category.SelectedCategoryID"
                                    cvLocalizedPlaceholder langSection="Common" langKey="Select">
                            <mat-select-trigger>{{getSelectorDisplay(category)}}</mat-select-trigger>

                            <div class="search-box live-search">
                                <input type="search" class="form-control form-control-lg" [(ngModel)]="search[category.SelectedCategoryID]" onkeydown="event.stopPropagation()"
                                       cvLocalizedPlaceholder langSection="Common" langKey="Search" maxlength="50"/>
                                <span class="clear-input" [hidden]="!search[category.SelectedCategoryID]" (click)="search[category.SelectedCategoryID] = ''"></span>
                            </div>

                            <mat-option [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + category.SelectedCategoryID + '-All') | cleanId" [value]="-1"
                                        (click)="onSelectAllToggled(category)">
                                <span cvLocalizedText langSection="Common" langKey="All">All</span>
                            </mat-option>

                            <cdk-virtual-scroll-viewport [itemSize]="36" [minBufferPx]="200" [maxBufferPx]="400" style="height:188px" [attr.category-id]="category.SelectedCategoryID">
                                <mat-option [value]="0" [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + category.SelectedCategoryID + '-NotSet') | cleanId"
                                            (onSelectionChange)="onSelectedAttributeValueChanged(category, $event)"
                                            [hidden]="search[category.SelectedCategoryID] && !service.localizationText.notSet.toLowerCase().includes(search[category.SelectedCategoryID].toLowerCase())">
                                    <span cvLocalizedText langSection="Controls" langKey="Not_Set">Not Set</span>
                                </mat-option>

                                <mat-option *cdkVirtualFor="let value of (service.attributeValues[attributeType][category.SelectedCategoryID] | filterText: search[category.SelectedCategoryID] : 'Name')"
                                            [value]="value.ID" [attr.category-id]="category.SelectedCategoryID" (onSelectionChange)="onSelectedAttributeValueChanged(category, $event)">{{value.Name}}</mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-select>
                    </mat-form-field>

                    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail d-flex align-items-center ml-2" (click)="onRemoveCategoryClicked(category)">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!--Add Attribute Button-->
    <div class="d-flex mt-2">
        <!--Spacer for showSelectedToggle state-->
        <button type="button" class="btn btn-text d-flex align-items-center align-self-end font-size-12 lato-regular" style="white-space:nowrap; visibility:hidden" *ngIf="showSelectedToggle">
            <div class="rounded border color-cerulean mr-2" style="height:0.5rem; width:0.5rem"></div>
            <div cvLocalizedText langSection="Admin_Attributes" langKey="View_By">View by</div>
        </button>

        <button type="button" class="btn btn-text btn-icon fill-cerulean font-size-12 pl-0" (click)="onAddAttributeClicked()" [hidden]="!categories || categories?.length <= selectedCategoryIds.size"
                [disabled]="maxSelectableCategories <= selectedCategoryIds.size">
            <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
            <span cvLocalizedText langSection="Common" langKey="Attribute">Attribute</span>
        </button>
    </div>
</div>

<!--Add Attribute View-->
<div class="px-2" [hidden]="!inCategoryView || maxSelectableCategories <= selectedCategoryIds.size || categories?.length <= 0">
    <button type="button" class="btn btn-text-gray btn-icon px-0 mb-2" (click)="onBackClicked()">
        <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
        <span cvLocalizedText langSection="Admin_Attributes" langKey="Choose_A_Category">Choose a Category</span>
    </button>

    <div class="search-box live-search mb-3">
        <input type="search" class="form-control form-control-lg" [(ngModel)]="categorySearchText" maxlength="50"
               cvLocalizedPlaceholder langSection="Common" langKey="Search" />
        <span class="clear-input" [hidden]="categorySearchText.length <= 0" (click)="categorySearchText = ''"></span>
    </div>

    <div class="font-size-16 overflow-auto pt-2" style="max-height:350px; border-top:1px solid #D2D6DB">
        <div class="mb-2 cursor-pointer" *ngFor="let cat of selectableCategories" (click)="onCategorySelected(cat)">{{cat.CategoryName}}</div>
    </div>
</div>

<!--Empty State-->
<div class="d-flex align-items-center px-2" *ngIf="categories?.length <= 0 && initialized">
    <svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg>
    <span class="color-valyrianSteel ml-1" [innerHTML]="emptyStateText"></span>
</div>
